var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('cHeader'),_c('cNav',{staticClass:"sticky-top"}),_c('cSection'),_c('cFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }